import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { StringUtils } from '@core/utils';
import { Observable } from 'rxjs';

export class BaseServiceService<T> {
    protected readonly httpClient = inject(HttpClient);

    constructor(protected readonly baseUri: string) {}

    public get(transactionId: string): Observable<T> {
        return this.httpClient.get<T>(StringUtils.parseUri(this.baseUri, { transactionId }));
    }

    public updateActive(transactionId: string, active: boolean): Observable<T> {
        return this.httpClient.patch<T>(StringUtils.parseUri(`${this.baseUri}/active`, { transactionId }), {
            value: active,
        });
    }

    public submit(transactionId: string, submit: boolean): Observable<T> {
        return this.httpClient.patch<T>(StringUtils.parseUri(`${this.baseUri}/submit`, { transactionId }), {
            value: submit,
        });
    }
}
